module.exports = __webpack_public_path__ + "img/textData.3fa645b2.png";